// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
const endpoint = "https://apiadminiplab.labsura.com";

export const environment = {
  production: false,

  //Endpoints
  companiaEndPoint: endpoint + "/appadminip/api/companias/",
  ciudadEndPoint: endpoint + "/appadminip/api/ciudades/",
  sedeEndPoint: endpoint + "/appadminip/api/sedes/",
  listaItemEndPoint: endpoint + "/appadminip/api/listaitems/",
  vlanEndPoint: endpoint + "/appadminip/api/vlans/",
  tipoAsignacionEndPoint: endpoint + "/appadminip/api/tipoasignacion/",
  administradorIpEndPoint: endpoint + "/appadminip/api/admin/",
  sesionEndPoint: endpoint + "/appadminip/api/sesion",
  inicioEndPoint: endpoint + "/appadminip/api/inicio",
  asignacionEndPoint: endpoint + "/appadminip/api/asignacion/",
  vlanSedeEndPoint: endpoint + "/appadminip/api/vlansede/",
  superNetEndPoint: endpoint + "/appadminip/api/supernet/",

  listaCodigoAmbientes: "AMBIEN",
  listaCodigoUrl: "LISURL",
  listaCodigoServidor: "LISSER",
  listaCodigoEquipos: "LISEQU",
  listaCodigoServicio: "SEITNE",
  listaCodigoPlataforma: "LISPLA",
  listaCodigoRol: "LISROL",
  listaCodigoMascara: "MASCAR",
  listaItemAmbienteSedes: "AMBSED",
  listaItemMascaraCloud: "4",

  tipoAsignacionManual: "MANUAL",

  miximoIpLiberar: 10,

  fechaInicial: "1989-05-13",
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts